import React, { useState, useEffect, useRef } from "react";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import ArrowRightIcon from "images/icons/arrow-right-icon.inline.svg";

export const AboutUsIntro = ({ aboutIntroContent, pageTitle }) => {
  const [pagination, setPagination] = useState(false);
  const contentElement = useRef(null);
  const breakpoint = useBreakpoint();

  useEffect(() => {
    if (breakpoint === "xs") setPagination(true);
    else setPagination(false);
  }, [breakpoint]);

  const handlePagination = () => {
    setPagination(false);
  };

  return (
    <section className="flex justify-center py-8 md:py-20 bg-yellow-lighter planet:bg-gray-dark">
      <div className="w-11/12 md:w-5/6 md:px-7 bg-inherit">
        <h1 className="pb-7 font-normal planet:font-light">{pageTitle}</h1>

        <div
          ref={contentElement}
          style={{ height: pagination ? "200vw" : "auto" }}
          className={`relative overflow-hidden flex flex-col md:flex-row gap-4 md:gap-24 text-black-lighter planet:text-gray-generic bg-inherit tab-content ${
            pagination
              ? "before:absolute before:w-[200vw] before:h-28 before:-right-24 before:md:-right-1/2 before:-bottom-4 before:md:-bottom-2 before:z-20 before:masked-overview before:masked-overview-top before:pagination-mask before:bg-inherit"
              : ""
          }`}
        >
          <div
            dangerouslySetInnerHTML={{ __html: aboutIntroContent }}
            className="columns-1 sm:columns-2 tab-content_html sm:gap-10"
          />
        </div>

        {pagination && (
          <button
            className="callback-button group flex justify-center items-center w-full md:w-auto py-2 px-12 md:mx-auto"
            onClick={handlePagination}
          >
            <p className=" pr-2">Read more</p>
            {/* <ArrowRightIcon className="stroke-black-lighter group-hover:stroke-white planet:stroke-white planet:group-hover:stroke-gray-darker rotate-90" /> */}
          </button>
        )}
      </div>
    </section>
  );
};
